var map = {
	"./article/facebook.svg": 512,
	"./article/favorite-checked.svg": 513,
	"./article/favorite-nonchecked.svg": 514,
	"./article/google.svg": 515,
	"./article/googleColor.svg": 516,
	"./article/instagram.svg": 517,
	"./article/link.svg": 518,
	"./article/pinterest.svg": 519,
	"./article/telegram.svg": 520,
	"./article/twitter.svg": 521,
	"./article/whatsapp.svg": 522,
	"./article/youtube.svg": 523,
	"./homepage/arrow-circle-right.svg": 524,
	"./neler-oluyor-game.svg": 525,
	"./neler-oluyor-news.svg": 526,
	"./right.svg": 527
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 511;